import { useState } from 'react';
import Icon from 'src/components/atoms/Icon';
import * as S from './styles';

interface Props {
  onChange: (query: string) => void;
}

export default function SearchMember({ onChange }: Props) {
  const [query, setQuery] = useState<string>('');
  const [focused, setFocused] = useState<boolean>();

  const handleChange = (value: string) => {
    onChange(value);
  };

  return (
    <S.InputWrapper focused={focused}>
      <S.Input
        type="search"
        value={query}
        placeholder="회원을 검색해주세요"
        onChange={e => {
          setQuery(e.target.value);
          handleChange(e.target.value);
        }}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      />
      <S.Button>
        <Icon name="IconSearch" />
      </S.Button>
    </S.InputWrapper>
  );
}
